import { render } from "./App.vue?vue&type=template&id=de744bac&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=de744bac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Aleix\\Feina\\PurpleTGames\\External\\Dreamtech5\\dreamtech-hyperbaric\\hiperbaric\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de744bac"]])

export default __exports__